import { searchRequestData, putRequest } from '../../Utility/apiHelper';
import qs from 'qs';

const ACTIONABLE_CONFIG = {
    task: {
        getUrl: 'api/task-actionables',
        markAsReadUrl: 'api/task-actionables/read',
        idKey: 'taskId',
        paramKey: 'taskIds'
    },
    lead: {
        getUrl: 'api/actionables',
        markAsReadUrl: 'api/actionables/read',
        idKey: 'leadId',
        paramKey: 'leadIds'
    }
};


export const getActionables = async (type, selectedOwner, ownerlist, myTeam) => {
    try {
        const cleanParams = {
            ...selectedOwner,
        };

        const allOwnerIds = (ownerlist || []).map(item => item.id);
        const reportingTeamIds = (myTeam || []).map(item => item.id);

        const selectedId = selectedOwner?.id;
        if (selectedId === "COMMON_ENTIRE_ORG") {
            cleanParams.ownerIds = allOwnerIds;
        } else if (selectedId === "COMMON_MY_TEAM") {
            cleanParams.ownerIds = reportingTeamIds;
        } else {
            cleanParams.ownerIds = [selectedId];
        }

        const config = ACTIONABLE_CONFIG[type];
        const searchUrl = `${process.env.REACT_APP_BASE_URL}${config.getUrl}`;

        const response = await searchRequestData(
            {
                params: cleanParams,
                paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
            },
            searchUrl,
            false
        );

        return response;

    } catch (error) {
        throw error;
    }
};

export const markAsRead = async (type, row) => {
    try {
        const config = ACTIONABLE_CONFIG[type];
        const url = `${process.env.REACT_APP_BASE_URL}${config.markAsReadUrl}`;

        const params = {
            [config.paramKey]: row[config.idKey],
            read: !row?.read
        };

        return await putRequest(url, params);

    } catch (error) {
        throw error;
    }
};

export const updateActionableReadStatus = (actionables, row, idKey) => {
    return actionables.map(item =>
        item[idKey] === row[idKey]
            ? { ...item, read: !item?.read }
            : item
    );
};
